import React from "react";
import { observer } from "mobx-react";
export const getLiveScoreboardComponent = (getLiveScoreboard) => React.memo(observer(getLiveScoreboard));
//# sourceMappingURL=getLiveScoreboardComponent.js.map